;(function($) {

    if(document.querySelector('#Content > .ProductUpdates')) {

        if(document.querySelector('a.toggle_nav')) {
            $(".toggle_nav").parent().children().filter(':not(a)').wrapAll('<div id="inpage_nav" class="csc-element collapse"></div>');

    		$("#inpage_nav a").click(function(e) {
    			if(e.target.hash) {
					e.preventDefault();
					$('html, body').stop().animate({
						scrollTop: $(e.target.hash).offset().top - 200
					}, 750, function () {
						//location.hash = e.target.hash;
					});
                }

                $(".toggle_nav").attr('class', 'toggle_nav collapsed');
                $(".toggle_nav").next().attr('class', 'csc-element collapse').attr('id', 'inpage_nav');
                $(".container.navigation").attr('class', 'container navigation closed');
    		});

            $('#inpage_nav').on('hidden.bs.collapse', function () {
                document.querySelector('.container.navigation').classList.add('closed');
            });
            $('#inpage_nav').on('shown.bs.collapse', function () {
                document.querySelector('.container.navigation').classList.remove('closed');
            });
        }

        const hero = document.querySelector('#hero');
        const updates = document.querySelector('#Content > .ProductUpdates');
        if (updates && (!hero || hero.children.length === 0)) {
            updates.classList.add('Neuheiten');
        }

        if(document.querySelector('#hero .imageBlockquote')) {
            document.querySelector('#Content > .ProductUpdates').classList.add('has-intro');
            document.getElementById('PageTitle').style.display = 'none';
        }

        var gals = document.querySelectorAll('.main .ce-gallery');

        $.each(gals, function(i, el) {
            if(el.children.length > 1) {
                // add classes & ID for carousel
                $(this).addClass('carousel slide').attr('id', 'carousel-'+i);
                // every slide should have carousel-item class
                $(this).find('.ce-row').addClass('carousel-item');
                // set first slide active
                $(this).find('.ce-row:first-child').addClass('active');

                var indic = '';

                // for each child
                $.each($(this).children(), function(n, itm) {

                    var num = n+1;
                    // create indicator for each child
                    if(n === 0) {
                        indic += "<a data-target='#carousel-"+i+"' data-slide-to='"+n+"' class='active' href='javascript:void()'>"+num+"</a>";
                    } else {
                        indic += "<a data-target='#carousel-"+i+"' data-slide-to='"+n+"' href='javascript:void()'>"+num+"</a>";
                    }
                });
                // wrap slides with carousel-inner
                $(this).wrapInner( "<div class='carousel-inner'></div>");
                // insert indicators
                $(this).append("<div class='indicators'>"+indic+"</div>");
                // indiciate carousel
                // $(this).carousel({
                //     interval: false
                // });
            }
        });

        $(".indicators a").click(function() {
            $(this).parent().find('.active').removeClass('active');
            $(this).addClass('active');
        });

        // strange (on load), but doesn't give valid sizes otherwise
        $(window).on('load', function() {
            // Keep red box just below text
            if(window.innerWidth >= 767 && document.querySelector('#hero .imageBlockquote')) {
                var margo = $("#hero .quote-wrapper").outerHeight() - $("#hero .imageBlockquote").height();
                var margoDiff = margo <= -70 ? margo : -70;
                $("#hero .imageBlockquote").css({ minHeight: $("#hero .quote-wrapper").outerHeight() + 100 });
                $(".ProductUpdates.has-intro #hero > .container").css({ marginTop: margoDiff });
            }
        });

        $(window).resize(function() {

            if(window.innerWidth >= 1068) {
                $(".toggle_nav").next().attr('class', 'csc-element collapse show').attr('id', 'inpage_nav');
            }

            // Keep red box just below text
            if(window.innerWidth >= 767 && document.querySelector('#hero .imageBlockquote')) {
                var margo = $("#hero .quote-wrapper").outerHeight() - $("#hero .imageBlockquote").height();
                var margoDiff = margo <= -70 ? margo : -70;
                $("#hero .imageBlockquote").css({ minHeight: $("#hero .quote-wrapper").outerHeight() + 100 });
                $(".ProductUpdates.has-intro #hero > .container").css({ marginTop: margoDiff });
            }
        });
    }
})(jQuery);
